import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCancelFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1149 414Q1149 440 1130 459L949 640L1130 821Q1149 840 1149 866Q1149 893 1130 912L1040 1002Q1021 1021 994 1021Q968 1021 949 1002L768 821L587 1002Q568 1021 542 1021Q515 1021 496 1002L406 912Q387 893 387 866Q387 840 406 821L587 640L406 459Q387 440 387 414Q387 387 406 368L496 278Q515 259 542 259Q568 259 587 278L768 459L949 278Q968 259 994 259Q1021 259 1040 278L1130 368Q1149 387 1149 414ZM1433.0 1025.5Q1536 849 1536.0 640.0Q1536 431 1433.0 254.5Q1330 78 1153.5 -25.0Q977 -128 768.0 -128.0Q559 -128 382.5 -25.0Q206 78 103.0 254.5Q0 431 0.0 640.0Q0 849 103.0 1025.5Q206 1202 382.5 1305.0Q559 1408 768.0 1408.0Q977 1408 1153.5 1305.0Q1330 1202 1433.0 1025.5Z"
	})
});
export default SvgCancelFill;
